import React from "react";
import { Languages, Loader2, X, ChevronDown, ChevronUp } from "lucide-react";

export const TR_LANGS = [["zh", "中文"], ["en", "English"], ["es", "Español"]];
/* 翻译默认目标 = 当前界面语言 */
export const defaultTarget = (zh) => (zh ? "zh" : "en");

/* 消息下方译文：可折叠 · 可切换 中 / 英 / 西 · 关闭 */
export const TranslationPanel = ({ m, zh, tr, onTarget, onToggle, onClose }) => {
  if (!tr) return null;
  return (
    <div data-testid={`chat-tr-${m.id}`} data-target={tr.target} data-open={tr.open ? 1 : 0} data-loading={tr.loading ? 1 : 0}
      className="mt-1 max-w-full rounded-xl border border-indigo-100 bg-indigo-50/60 text-[12px] text-slate-700">
      <div className="flex items-center gap-1.5 px-2.5 py-1">
        <button type="button" data-testid={`chat-tr-toggle-${m.id}`} onClick={onToggle} className="inline-flex items-center gap-1 text-[10px] font-semibold text-[#4F6BFF]">
          <Languages className="h-3 w-3" />{zh ? "译文" : "Translation"}{tr.open ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
        </button>
        <span className="inline-flex gap-0.5 ml-1">
          {TR_LANGS.map(([k, l]) => <button type="button" key={k} data-testid={`chat-tr-lang-${m.id}-${k}`} data-on={tr.target === k ? 1 : 0} onClick={() => onTarget(k)}
            className={`rounded-full px-1.5 py-px text-[10px] ${tr.target === k ? "bg-[#4F6BFF] text-white" : "text-slate-500 hover:bg-white"}`}>{l}</button>)}
        </span>
        {tr.loading && <Loader2 className="h-3 w-3 animate-spin text-slate-400" />}
        <button type="button" data-testid={`chat-tr-close-${m.id}`} onClick={onClose} className="ml-auto text-slate-400 hover:text-slate-700" aria-label="close"><X className="h-3 w-3" /></button>
      </div>
      {tr.open && <p data-testid={`chat-tr-text-${m.id}`} className="px-2.5 pb-2 whitespace-pre-wrap break-words leading-relaxed">{tr.loading && !tr.text ? (zh ? "翻译中…" : "Translating…") : tr.text}</p>}
    </div>
  );
};
